module.exports = __webpack_public_path__ + "media/Wave.ba977e4d.wav";